import { render, staticRenderFns } from "./DashboardFilterRegions.vue?vue&type=template&id=b7408df4"
import script from "./DashboardFilterRegions.vue?vue&type=script&lang=js"
export * from "./DashboardFilterRegions.vue?vue&type=script&lang=js"
import style0 from "./DashboardFilterRegions.vue?vue&type=style&index=0&id=b7408df4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports